import React, { useContext } from 'react';
import { TextStyle_TextAlignment } from 'ricos-schema';
import { RicosViewerContext, RicosDirectionContext, RicosNodeContext, RicosNodeContextProvider } from 'ricos-context';
import { s as styles } from '../../../../lists-16976e92.js';
import { r as rtlStyles } from '../../../../rtl.rtlignore-09de95fb.js';
import classnames from 'classnames';
import { isPaywallSeo, getPaywallSeoClass } from '../../utils/paywallSeo.js';
import { a as alignmentStyle } from '../../../../alignment.rtlignore-4565cad7.js';
import { TO_DIR } from '../consts.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListItem = ({ node, nodeIndex, RicosNodesRenderer }) => {
  var _a, _b;
  const { seoMode } = useContext(RicosViewerContext);
  const { textDirection } = useContext(RicosDirectionContext);
  const { parentIndex } = useContext(RicosNodeContext);
  const firstChild = node.nodes[0];
  const dataProperty = `${(_a = firstChild == null ? void 0 : firstChild.type) == null ? void 0 : _a.toLowerCase()}Data`;
  const { textAlignment } = ((_b = firstChild == null ? void 0 : firstChild[dataProperty]) == null ? void 0 : _b.textStyle) || {};
  const dir = TO_DIR[textAlignment] || textDirection;
  const listItemClassName = classnames(
    styles.listItem,
    alignmentStyle[textAlignment || TextStyle_TextAlignment.AUTO],
    rtlStyles[dir],
    isPaywallSeo(seoMode) && getPaywallSeoClass((seoMode == null ? void 0 : seoMode.paywall) || {}, nodeIndex + parentIndex)
  );
  return /* @__PURE__ */ React.createElement("li", { dir: dir || "auto", className: listItemClassName }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes, shouldParagraphApplyTextStyle: true }))));
};
const ListItemRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(ListItem, __spreadValues({ key: node.id, node }, props));
};

export { ListItemRenderer as default };
//# sourceMappingURL=listItem.js.map
